import { render, staticRenderFns } from "./KnowledgeCheckHeader.vue?vue&type=template&id=edfd09e2&scoped=true&lang=pug"
import script from "./KnowledgeCheckHeader.vue?vue&type=script&lang=ts"
export * from "./KnowledgeCheckHeader.vue?vue&type=script&lang=ts"
import style0 from "./KnowledgeCheckHeader.vue?vue&type=style&index=0&id=edfd09e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfd09e2",
  null
  
)

export default component.exports